import React from 'react';
import { motion } from 'framer-motion';
import { FiPhoneCall, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Founder = () => {
  return (
    <section className="py-24 bg-slate-50 border-t border-slate-100 relative overflow-hidden" id="founder">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-emerald-100/50 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-[2rem] shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden p-8 md:p-12 lg:p-16"
        >
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900">Hi, I'm Andrew Khong</h2>
            <p className="text-emerald-600 font-bold mt-2 tracking-wide uppercase text-sm">Founder, Toptier Ventures LLC</p>
          </div>

          <div className="space-y-6">
            <p className="text-slate-600 text-lg leading-relaxed font-light">
              "I started Toptier Ventures LLC because I saw how many homeowners and business owners wanted to break into real estate, but lacked the proper education. Land flipping is a hidden gem in the industry, and I wanted to demystify it."
            </p>
            <p className="text-slate-600 text-lg leading-relaxed font-light">
              "When you enroll in our programs, you're getting access to the exact systems I've used to succeed. My goal is to empower you with the knowledge, products, and services you need to make money flipping land and build true financial freedom."
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a 
              href="#get-offer" 
              className="inline-flex items-center justify-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-xl font-semibold hover:bg-slate-800 transition-all hover:shadow-lg hover:-translate-y-0.5"
            >
              <SafeIcon icon={FiPhoneCall} className="text-emerald-400" />
              Book a Strategy Call
            </a>
          </div>

          {/* Personal Guarantee */}
          <div className="mt-10 pt-8 border-t border-slate-100 flex items-center gap-3">
            <SafeIcon icon={FiCheckCircle} className="text-emerald-500 text-2xl flex-shrink-0" />
            <p className="text-sm font-medium text-slate-500">
              <strong className="text-slate-700">My Commitment to You:</strong> We are dedicated to providing the highest quality real estate education to ensure our students have everything they need to succeed.
            </p>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default Founder;